export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000' as const;
export const WBNB_BURN_CONVERTER_DESTINATION_ADDRESS =
  '0x0000000000000000000000000000000000000001' as const;
